var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader',{attrs:{"task":_vm.task}}),(_vm.emailCampaign)?_c('report',{attrs:{"email-campaign":_vm.emailCampaign},on:{"refreshed":_vm.refresh}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }